module.exports = __webpack_public_path__ + "static/img/eye-o.43ff6b1a.svg";